import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { pickBy } from 'lodash';
import { BiContainer, BiProvider } from 'seagull';
import { useIoContext, useStoreStatic } from '~/contexts';
import { useEventReporter } from '~/event-reporter';
import { selectors } from '~/store/state-selectors';
import { usePageViewTracking } from './usePageViewTracking/usePageViewTracking';
const BiPageTrackingProvider = (param)=>{
    let { children } = param;
    const [pageBiData, setPageBiData] = useState(undefined);
    usePageViewTracking({
        setPageBiData
    });
    return /*#__PURE__*/ _jsx(BiContainer, {
        name: pageBiData === null || pageBiData === void 0 ? void 0 : pageBiData.pageName,
        data: pageBiData === null || pageBiData === void 0 ? void 0 : pageBiData.pageEvent,
        children: children
    });
};
export const BiFrontendProvider = (param)=>{
    let { children } = param;
    const { logBIEvent: _logBIEvent, getNow } = useIoContext();
    const { getState } = useStoreStatic();
    const { heapTrack } = useEventReporter();
    const logBIEvent = useCallback((biEvent)=>{
        const state = getState();
        const user_id = selectors.user.id(state);
        const business_id = selectors.user.businessId(state);
        const business_type = selectors.user.isVendor(state) ? 'service_provider' : selectors.user.isClient(state) ? 'client' : 'unknown';
        const ff = pickBy(selectors.ff.featureFlagsData(state));
        const enrichedEvent = _object_spread({
            client_timestamp: getNow().toISOString(),
            user_id,
            business_id,
            business_type,
            ff
        }, biEvent);
        _logBIEvent(enrichedEvent);
        if (ff.HEAP_BI_MIRROR && typeof (biEvent === null || biEvent === void 0 ? void 0 : biEvent.type) === 'string') {
            const { ff: _omitFf } = enrichedEvent, heapPayload = _object_without_properties(enrichedEvent, [
                "ff"
            ]);
            heapTrack(biEvent.type, heapPayload);
        }
    }, [
        _logBIEvent,
        heapTrack
    ]);
    return /*#__PURE__*/ _jsx(BiProvider, {
        logBi: logBIEvent,
        children: /*#__PURE__*/ _jsx(BiPageTrackingProvider, {
            children: children
        })
    });
};
